<p
  class="nordic-blue-900-text"
  *ngIf="(isApisCompleted$ | async) === false || (passengerInAgentReval$ | async); else apisComplete"
>
  {{ 'MMB.checkIn.steps.apis.informationMessage' | finLocalization }}
</p>

<ng-template #apisComplete>
  <p class="nordic-blue-900-text">
    {{ 'MMB.checkIn.steps.apis.informationMessageApisComplete' | finLocalization }}
  </p>
</ng-template>

<fcom-notification
  class="ps-xlarge-t"
  *ngIf="(isApisCompleted$ | async) === false && (passengerInAgentReval$ | async) === false"
  [theme]="NotificationTheme.INFO"
  [layout]="NotificationLayout.BLOCK"
  [iconName]="SvgLibraryIcon.INFO_BLOCK"
  [title]="'MMB.checkIn.steps.apis.usePassportOnlyNotification.title' | finLocalization"
>
  {{ 'MMB.checkIn.steps.apis.usePassportOnlyNotification.content' | finLocalization }}
</fcom-notification>

<fcom-notification *ngIf="passengerInAgentReval$ | async" class="ps-medium-t" [theme]="NotificationTheme.ALERT">
  {{ 'MMB.apis.notification.inAgentReval' | finLocalization }}
</fcom-notification>

<h3 class="nordic-blue-900-text ps-xlarge-t ps-large-b font-heading-4">
  {{ 'MMB.checkIn.funnel.steps.apis.passengers' | finLocalization }}
</h3>
<fin-apis-pax
  *ngFor="let passenger$ of passengers$ | finObsToArray; first as isFirst"
  class="block"
  [class.mr-large-t]="!isFirst"
  [order$]="order$"
  [boundId$]="boundId$"
  [passenger$]="passenger$"
  [ctaOpenApisFormAction$]="ctaOpenApisFormAction$"
  (goToMmb)="goToMmb()"
></fin-apis-pax>

<fcom-cta-button
  [title]="
    ((passengerInAgentReval$ | async) ? 'MMB.apis.ctaButton.inAgentReval' : 'actions.continue') | finLocalization
  "
  [position]="ButtonPosition.GRID_FULL"
  (buttonClicked)="continueToNextStep()"
>
  <span class="gray-50-text" data-testid="apis-helper-description"
    >{{
      ((passengerInAgentReval$ | async)
        ? 'MMB.apis.ctaButton.inAgentRevalDescription'
        : (canContinue$ | async)
          ? 'MMB.checkIn.steps.apis.nextStepButton'
          : (passengers$ | finObsToArray)?.length === 1
            ? 'MMB.checkIn.steps.apis.provideAllInformation'
            : 'MMB.checkIn.steps.apis.nextPassengerApisForm'
      ) | finLocalization
    }}
  </span>
</fcom-cta-button>
